<template>
  <div id="ApplyReg"> 
    <img :src="imgUrl" alt="申请流程">
  </div>
</template>
<script>
export default {
  name:"ApplyReg",
  data(){
    return{
      imgUrl:require("@/assets/applyReg.jpg")
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../Common/common.styl"
</style>



// WEBPACK FOOTER //
// src/components/Custody/ApplyReg.vue